import styled from 'styled-components'

export const ProgressHolder = styled.div`
  width: 200px;
  margin-bottom: 40px;
`
